module.exports = __webpack_public_path__ + "img/kerala_camp_hero_card_1.7f4b5fcb.jpg";